/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do buffer recipes scale?`)
};

const es_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo escalan las recetas de buffer?`)
};

const de_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie skalieren Pufferrezepte?`)
};

const nl_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe schalen buffer-recepten?`)
};

const fr_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les recettes de tampon s'adaptent-elles ?`)
};

const it_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come scalano le ricette dei buffer?`)
};

const pt_br2_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as receitas de tampão são dimensionadas?`)
};

const pt_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como escalam as receitas de tampão?`)
};

const ja_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッファーのレシピはどのようにスケーリングされますか?`)
};

const zh_buf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缓冲液配方是如何按比例放大的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_faq_q1", locale)
	if (locale === "en") return en_buf_faq_q1(inputs)
	if (locale === "es") return es_buf_faq_q1(inputs)
	if (locale === "de") return de_buf_faq_q1(inputs)
	if (locale === "nl") return nl_buf_faq_q1(inputs)
	if (locale === "fr") return fr_buf_faq_q1(inputs)
	if (locale === "it") return it_buf_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_buf_faq_q1(inputs)
	if (locale === "pt") return pt_buf_faq_q1(inputs)
	if (locale === "ja") return ja_buf_faq_q1(inputs)
	return zh_buf_faq_q1(inputs)
};